import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAllRecurring, pauseRecurring, resumeRecurring } from "./RecurringService";


export default function RecurringList(){
const [items,setItems] = useState([]);
const nav = useNavigate();


useEffect(()=>{ load(); },[]);


const load = async ()=>{
const data = await getAllRecurring();
setItems(data);
};


return (
<div style={wrap}>
<h2>Recurring Payments</h2>


<button onClick={()=>nav("new")}>➕ Add Recurring</button>


<div style={grid}>
{items.map(r=> (
<div key={r.id} style={card}>
<div style={title}>{r.title}</div>
<div>{r.type}</div>
<div>₹ {r.amount}</div>
<div>{r.frequency}</div>
<div>Next: {r.nextRunDate}</div>


<div style={actions}>
{r.active
? <button onClick={async()=>{ await pauseRecurring(r.id); load(); }}>⏸ Pause</button>
: <button onClick={async()=>{ await resumeRecurring(r.id); load(); }}>▶ Resume</button>
}
</div>
</div>
))}
</div>
</div>
);
}


const wrap = { padding:"20px" };
const grid = { display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(260px,1fr))", gap:"16px" };
const card = { background:"#fff", padding:"16px", borderRadius:"14px", boxShadow:"0 8px 20px rgba(0,0,0,0.08)" };
const title = { fontWeight:"600", fontSize:"16px" };
const actions = { marginTop:"10px" };